import { render } from "./Image_Swiper_Set.vue?vue&type=template&id=4912237c&scoped=true"
import script from "./Image_Swiper_Set.vue?vue&type=script&lang=js"
export * from "./Image_Swiper_Set.vue?vue&type=script&lang=js"

import "./Image_Swiper_Set.vue?vue&type=style&index=0&id=4912237c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4912237c"]])

export default __exports__